import { Component, inject } from '@angular/core';
import { LucideAngularModule, ArrowRight } from 'lucide-angular';
import { ModalService } from '../services/modal.service';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-cta',
  standalone: true,
  imports: [LucideAngularModule, TranslateModule],
  template: `
    <section class="py-24 md:py-32 bg-dark-100 relative overflow-hidden">
      <!-- Single warm glow -->
      <div class="absolute bottom-0 left-1/2 -translate-x-1/2 w-[400px] h-[300px] bg-primary/[0.06] rounded-full blur-[100px] pointer-events-none"></div>

      <div class="max-w-3xl mx-auto px-5 md:px-10 relative z-10 text-center" data-aos="zoom-in-up">
        <h2 class="text-3xl sm:text-4xl md:text-5xl font-black mb-6 leading-[1.05] tracking-tight">
          {{ 'CTA.TITLE_1' | translate }}
          <span class="text-gradient">{{ 'CTA.TITLE_2' | translate }}</span>
        </h2>
        
        <p class="text-base text-gray-450 mb-10 max-w-md mx-auto">
          {{ 'CTA.DESC' | translate }}
        </p>

        <button (click)="modalService.openComingSoon($event)" class="inline-flex items-center gap-2 px-8 py-4 rounded-full bg-primary text-white font-bold text-sm hover:bg-primary-dark transition-colors shadow-cta hover:shadow-cta-hover">
          {{ 'CTA.BTN' | translate }}
          <lucide-icon [img]="ArrowRight" class="w-4 h-4"></lucide-icon>
        </button>
      </div>
    </section>
  `
})
export class CtaComponent {
  modalService = inject(ModalService);
  readonly ArrowRight = ArrowRight;
}
